import {
  MARK_MESSAGE_READ
} from '@actions/types'

export const markMessageReadAction = ({ apiKey, hash, data }) => ({
  type: MARK_MESSAGE_READ,
  payload: {
    request: {
      method: 'post',
      url: `receipts/${hash}`,
      data: {
        ids: [data]
      },
      headers: { 'x-api-key': apiKey }
    }
  }
})
